<script>
export default {
  name: "InnerButton",
  functional: true,
  render: function (h, { props, parent, children, listeners, data, ...args }) {
    const { name, enumValues, value, showLabel } = props;
    if (!Array.isArray(enumValues)) return;
    const click = listeners.click;
    return (
      <div class={'inner_button_div'} style="display: flex; flex-direction: row; align-items: baseline;">
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        {enumValues.map(enumValue =>
          <button style="margin-right: 12px"
            key={enumValue.name || enumValue.Name} class={((value === enumValue.value || value === enumValue.Value) ? 'warm_button_select' : '') + ' warm_button warm_button_left'} onClick={() => click(enumValue)}>
            {enumValue.name || enumValue.Name}
          </button>)}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";

.warm_button {
  padding: 0 5px;
}
.inner_button_div{
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-top: 6px;
}
</style>
